import { AutoTableColumn } from "./AutoTableColumn";
import styles from "./AutoTable.module.scss";
import { classNames } from "../../Utilities";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface AutoTableProps<T> {
    items: T[] | null;
    columns: AutoTableColumn<T>[];
    rowKey: (item: T) => string;
    className?: string;
    noDataText?: string;
    createRow?: boolean;
    sortColumnKey?: string;
    sortDescending?: boolean;
    onSort?: (columnKey: string, descending: boolean) => void;
    onRowClick?: (item: T) => void;
}

export const AutoTable = <T,>(props: AutoTableProps<T>) => {
    const columns = props.columns.filter(column => !column.hidden);

    const handleColumnClicked = (column: AutoTableColumn<T>): void => {
        if (!column.key) return;

        if (props.sortColumnKey === column.key) {
            props.onSort?.(props.sortColumnKey, !props.sortDescending);
        }
        else {
            props.onSort?.(column.key, false);
        }
    };

    if (!props.items) return null;

    return (
        <table className={props.className ?? ""}>

            <thead>
                <tr>

                    {columns.map((column, index) => (
                        <th
                            key={index}
                            className={classNames([
                                styles.headings,
                                column.className,
                                !!props.onRowClick && column.key && styles.clickable
                            ])}
                            onClick={() => handleColumnClicked(column)}

                        >
                            <div className={styles.heading}>
                                <div className={styles.title}>
                                    {column.header}
                                </div>
                                {column.key && props.sortColumnKey === column.key && (
                                    <div className={styles.sortIcon}>
                                        {props.sortDescending ? <FontAwesomeIcon icon={faCaretDown} /> : <FontAwesomeIcon icon={faCaretUp} />}
                                    </div>
                                )}
                            </div>
                        </th>
                    ))}

                </tr>
            </thead>

            <tbody>

                {!props.items?.length && (
                    <tr>
                        <td colSpan={columns.length} className={styles.noData}>
                            {props.noDataText ?? "No data"}
                        </td>
                    </tr>
                )}

                {props.items.map(item => (
                    <tr
                        key={props.rowKey(item)}
                        onClick={() => props.onRowClick?.(item)}
                        className={classNames([styles.row, !!props.onRowClick && styles.clickable])}
                    >
                        {columns.map((column, index) => (
                            <td key={index} className={column.className ?? ""}>{column.display(item)}</td>
                        ))}
                    </tr>
                ))}

                {props.createRow && (
                    <tr>
                        {columns.map((column, index) => (
                            <td key={index}>{column.createDisplay}</td>
                        ))}
                    </tr>
                )}

            </tbody>
        </table>
    );
};